export default "__VITE_ASSET__CCbc_fkJ__"